module.exports = __webpack_public_path__ + "band_11.9ccf1a95.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/female_to_male/band_11.png
// module id = vztM
// module chunks = 0